import React from 'react'

import BkFlowCurrencyToggle from '../../../currency/BkFlowCurrencyToggle'
import BkFlowLanguageToggle from '../../../language/BkFlowLanguageToggle'

import yn from 'yn'
import BkFlowNavigationProfile from "../profile/BkFlowNavigationProfile";
import BkFlowMaterialLoader from "../../../elements/BkFlowMaterialLoader";

if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'basic') {
	require('../../../../styles/css/components/navigation/bk-flow-navigation-basic.css')
}

const BkFlowNavigationBasic = props => {
	const {
		activeCurrencyData,
		exchangeRatesLoading,
		hotel,
		hotelLogo,
		hotelLink,
		openEditModal
	} = props

	let headerClasses = 'bk-flow-header'

	if (
		yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION) &&
		yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES)
	) {
		headerClasses = 'bk-flow-header basic sticky inc-utility'
	} else if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
		headerClasses = 'bk-flow-header basic sticky'
	} else if (yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)) {
		headerClasses = 'bk-flow-header basic inc-utility'
	}

	return (
		<header role="banner">
			<div className={headerClasses}>
				<nav>
					<div className="bk-flow-navigation">
						<div className="u-container u-remove-padding">
							<div className="row">
								<div className="bk-flow-navigation__column column-logo">
									{ hotelLogo &&
										<a
											className="bk-flow-navigation__logo"
											href={ hotelLink ? hotelLink : '/' }
											tabIndex={0}
										>
											{ hotelLogo }
										</a>
									}
								</div>

								<div className="bk-flow-navigation__column column-hotel">
									<div
										id="bk-toggle-edit-stay"
										className="bk-flow-navigation__edit-stay u-font-bold js-toggle__edit-stay"
										onClick={ openEditModal }
										tabIndex={ 0 }
									>
										<h1 className="u-remove-margin">{hotel}</h1>
									</div>
								</div>

								<div className="bk-flow-navigation__column column-utilities">
									{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE) &&
										yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
										exchangeRatesLoading ?
										<BkFlowMaterialLoader
											parentClasses='u-txt-center'
											color={'#000'}
											size={15}
										/>
									: yn(process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE) &&
										yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
										activeCurrencyData &&
										activeCurrencyData.exchangeRate &&
										activeCurrencyData.currencyCode ?
										<BkFlowCurrencyToggle
											isMobile={ false }
											displayLabel={ true }
										/>
									:
										null
									}

									{ yn(process.env.REACT_APP_COMPONENT_ENABLE_LANGUAGE_TOGGLE) &&
										<BkFlowLanguageToggle />
									}

									{ yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
										<BkFlowNavigationProfile />
									}
								</div>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</header>
	)
}

export default BkFlowNavigationBasic


// WEBPACK FOOTER //
// ./src/components/structure/navigation/layouts/BkFlowNavigationBasic.js